import React from 'react';
import styles from './comp.module.scss';
import MainControls from './components/MainControls';
import ActionEditor from './components/ActionEditor';
import Footer from './components/Footer';
import { Layout } from 'antd';
const { Content } = Layout;
const Comp = () => {
    const list = ['1', 'abc'];
    let peekValue;
    peekValue = list.pop();
    return (<Layout className={styles.wrap}>
      <Content className={styles.mainContent}>
        <Content className={styles.content}>
          <MainControls />
          <ActionEditor />
          <Footer />
        </Content>
      </Content>
    </Layout>);
};
export default Comp;
